import React from "react";

/**
 * Empty state illustration for documents table.
 * 3D folder icon with document and X badge.
 */
const EmptyDocumentsIllustration = ({ className = "!w-12 !h-12 !mx-auto" }) => (
  <img
    src="/assets/empty-documents.png"
    alt=""
    className={className}
    aria-hidden
    height={200}
    width={200}
  />
);

export default EmptyDocumentsIllustration;
